"use client";

import type { TextColor } from "@homeinstead/schemas";
import type { FranchiseInquiryFormInput } from "./franchiseInquiry.schema";

import { cn } from "@homeinstead/ui";
import { useFormContext } from "react-hook-form";
import { inquiryTextColorClass } from "~www/components/LeadForm/Inquiry";

type FranchiseInquiryMarketingOptInProps = {
  textColor?: TextColor;
};

function FranchiseInquiryMarketingOptIn({
  textColor,
}: FranchiseInquiryMarketingOptInProps) {
  const { register } = useFormContext<FranchiseInquiryFormInput>();

  return (
    <label
      className={cn(
        "flex cursor-pointer items-start gap-3 text-sm leading-relaxed",
        inquiryTextColorClass(textColor),
      )}
    >
      <input
        className="mt-0.5 h-4 w-4 shrink-0 cursor-pointer accent-new-beginnings-base"
        type="checkbox"
        {...register("marketingOptIn")}
      />
      <span>
        I also give permission for Home Instead to contact me via email about
        future events, activities and news. (you can unsubscribe at any time).
      </span>
    </label>
  );
}

export { FranchiseInquiryMarketingOptIn };
